export default __webpack_public_path__ + "static/media/19.cb8059a5.jpg";